<template>
  <div class="cb-notebar" :class="[customClass, notesSecondaryClass, noteTypeClass]" v-if="message">
    <div class="cb-notebar__wrap">
      <div class="cb-notebar__icon" v-if="type">
        <i class="icon-info-circle" :class="'cb-notebar__'+type" v-if="type == 'info' || type == 'warning' || type == 'error' || type == 'suggestion' || type == 'muted'"></i>
        <!--Info: Note with plain bg-->
        <!--Warning: Note with yellow bg and normal font color-->
        <!--Error: Note with yello bg and  danger font color-->
        <!--Suggestion: Info Note with blue bg-->
        <i class="icon-exclamation-circle cb-notebar__alert" v-else></i>
      </div>
      <div class="cb-notebar__content" v-cb-html="message" v-if="message">
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import {
  mapGetters
} from 'vuex'
export default {
  props: ['customClass', 'type', 'message'],
  data(){
    return {
      notesSecondaryClass:'',
      noteTypeClass: ''
    }
  },
  mounted(){

    switch(this.type) {
      case 'warning':
        this.noteTypeClass = 'cb-notebar--warning';
        break;
      case 'error':
        this.noteTypeClass = 'cb-notebar--error';
        break;
      case 'suggestion':
        this.noteTypeClass = 'cb-notebar--suggestion';
        break;
      case 'muted':
        this.noteTypeClass = 'cb-notebar--muted';
        break;
    }

    if(this.type=='warning' || this.type=='error' || this.type=='suggestion'){
      this.notesSecondaryClass = 'cb-notebar--secondary';
    }

  }
}
</script>



// WEBPACK FOOTER //
// Notes.vue?756feec3